_workerCatchThrown